<template>
  <CRow>
    <CCol sm="12">

      <CCard>

        <CCardHeader>
          <CIcon name="cil-text"/>
          Einen neuen Hersteller anlegen
        </CCardHeader>

        <CCardBody>
          <ValidationObserver v-slot="{ invalid }">
            <CForm class="no-mb" @submit.prevent="createHersteller()">

              <HerstellerText v-model="herstellernr" formLabel="Hersteller Nummer" rules=""/>
              <HerstellerText v-model="hersteller" formLabel="Name"/>

              <FormError v-if="formError" :errormessage="formError"/>

              <CRow class="mt-4">
                <CCol col="12" class="text-right">
                  <CButton color="primary" class="px-4" :disabled="invalid" type="submit">Hersteller anlegen</CButton>
                </CCol>
              </CRow>

            </CForm>
          </ValidationObserver>
        </CCardBody>

      </CCard>

    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue'
import FormError from '@/components/FormError'
import HerstellerText from '@/components/FormElements/Text'

export default {
  name: 'HerstellerNew',
  components: {
    FormError,
    HerstellerText
  },
  data () {
    return {
      herstellernr: '',
      hersteller: '',
      formError: null
    }
  },
  mounted () {
    this.setDefaults()
  },
  methods: {
    setDefaults () {
      this.herstellernr = ''
      this.hersteller = ''
      this.formError = null
    },
    createHersteller () {
      Vue.axios.post('/hersteller/post', {
        herstellernr: this.herstellernr && this.herstellernr.trim() !== '' ? this.herstellernr.trim() : null,
        hersteller: this.hersteller ? this.hersteller.trim() : ''
      }).then((response) => {
        this.$router.push({ path: '/hersteller/uebersicht' })
        this.$snotify.success('Der neue Hersteller wurde angelegt.', {
          position: 'rightTop',
          timeout: 4000
        })
        this.setDefaults()
      }).catch((error) => {
        this.formError = error.response.data
      })
    }
  }
}
</script>
